import * as yup from "yup";

const acceptValidationSchema = yup.object({
  confirm_legal_right: yup.boolean().required().isTrue(),
  confirm_licenses: yup.boolean().required().isTrue(),
  declare_foregoing_true: yup.boolean().required().isTrue(),
});

export default acceptValidationSchema;
